export default "__VITE_ASSET__gJq7V8_B__"